/* eslint-disable angular/module-name */
angular.module('zc.projects.heatmap', [
  'ngResource',
  'zc.commonApi',
  'zc.core',
  'zc.projects'
]);




// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.heatmap/zc.projects.heatmap.module.js